import http from '../../http/base';

export default ({ API_PATHS }) => ({
    checkBankingRequired: membersGuids =>
        http.get(API_PATHS.bankingCheck, { params: { membersGuids } }),

    checkReimbursementEnabled: membersGuids =>
        http.get(API_PATHS.reimbursementCheck, { params: { membersGuids } }),
});
